var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex align-item-center hidden-extra-content"},_vm._l((5),function(item,index){return _c('v-sheet',{key:index,staticClass:"pa-0",attrs:{"color":"grey lighten-4 mr-5"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"width":"140px","height":"100px","type":"image"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }